import { LegalTemplate } from 'components/UI/LegalTemplate';
import { LEGAL_COUNTRY_LANGUAGE_CODES } from 'util/config/constant';
import { useSelector } from 'react-redux';
import { selectLegalLanguageCode } from 'state/global/legal/selector';
import { ContentLocaleDe } from './components/ContentLocaleDe';
import { ContentLocaleSv } from './components/ContentLocaleSv';
import { ContentLocaleSw } from './components/ContentLocaleSw';
import { ContentLocaleFr } from './components/ContentLocaleFr';
import { ContentLocaleNl } from './components/ContentLocaleNl';
import { ContentLocalePl } from './components/ContentLocalePl';
import { ContentLocaleEs } from './components/ContentLocaleEs';
import { ContentLocaleEnGb } from './components/ContentLocaleEnGb';
import { ContentLocaleUsa } from './components/ContentLocaleUsa';

export const PrivacyPolicy = () => {
  const legalCountryLanguageCode = useSelector((state) =>
    selectLegalLanguageCode(state)
  );

  const renderContent = () => {
    switch (legalCountryLanguageCode) {
      case LEGAL_COUNTRY_LANGUAGE_CODES.DE:
        return <ContentLocaleDe />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.SV:
        return <ContentLocaleSv />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.SW:
        return <ContentLocaleSw />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.FR_BE:
        return <ContentLocaleFr />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.NL_BE:
        return <ContentLocaleNl />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.PL:
        return <ContentLocalePl />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.ES:
        return <ContentLocaleEs />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.EN_GB:
        return <ContentLocaleEnGb />;
      case LEGAL_COUNTRY_LANGUAGE_CODES.USA:
        return <ContentLocaleUsa />;

      default:
        return <></>;
    }
  };

  return <LegalTemplate>{renderContent()}</LegalTemplate>;
};
